import {Component, signal} from '@angular/core';
import {NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-expansion-panel',
  imports: [
    NgOptimizedImage
  ],
  templateUrl: './expansion-panel.component.html',
  styleUrl: './expansion-panel.component.css'
})
export class ExpansionPanelComponent {
  isOpen = signal(false)

  onToggle() {
    this.isOpen.update(value => !value);
  }
}
